import React, { Component } from "react";
import { sanitizeParams } from "wvus-sponsorship-engine";
import sanitizeHtml from "sanitize-html";


export function getWindowObject() {
  return typeof window !== "undefined" ? window : {};
}

export function getAppSettings() {
  // Check The Window Object To Get The App Settings
  const windowObject = getWindowObject();
  return windowObject.wv_rcds && windowObject.wv_rcds.settings;
}

export function getAdditionalParams() {
  // Check The Window Object To Get additional params
  const windowObject = getWindowObject();
  const additionalParams = windowObject.additionalParams || {};
  const additionalCtaParams = windowObject.additionalCtaParams || {};

  const params = {...additionalParams, ...additionalCtaParams};

  if (params === Object(params)) {
    const paramStr = Object.keys(params).reduce((acc, key) => {
      const value = params[key];
      let accStr = acc;

      if (additionalParams[key]) {
        accStr = `${accStr}&${key}[]=${value}`;
      }

      if (additionalCtaParams[key]) {
        accStr = `${accStr}&${key}=${value}`;
      }

      return accStr;
    }, "");

    return paramStr;
  }

  return "";
}








export function getSearchDefaultParams() {
  const settings = getAppSettings();
  const ageRange = settings.ageRange ? settings.ageRange : null;

  const defaultParams = {
    ...settings.searchDefault,
    minimumAge: ageRange && ageRange.min ? ageRange.min : "",
    maximumAge: ageRange && ageRange.max ? ageRange.max : "",
    countryCodes: settings.countries ? settings.countries : [],
    gender: settings.gender ? settings.gender : "",
    orphan: settings.orphan ? settings.orphan : 0,
    disabledFlag: settings.disabledChildren ? settings.disabledChildren : 0,
    minimumDaysAwaitingSponsorshipCount: settings.daysAwaitingSponsorship
      ? settings.daysAwaitingSponsorship
      : "",
  };

  return (defaultParams && sanitizeParams(defaultParams, "searchTerm")) || {};
}

export function mergeSearchDefaultParams(params = {}) {
  const defaultSearchParms = getSearchDefaultParams();
  const overrideSearchParams = sanitizeParams(params, "searchTerm");

  // Use Object Assign To Overwrite The Defaults
  return Object.assign({}, defaultSearchParms, overrideSearchParams);
}

// Allow only a super restricted set of tags and attributes
export function cleanHtml(dirty) {
  return sanitizeHtml(dirty, {
    allowedTags: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "p",
      "img",
      "h2",
      "h3",
      "li",
      "ul",
      "br",
    ],
    allowedAttributes: {
      a: ["href", "class"],
      img: ["src", "class"],
      p: ["class"],
    },
    transformTags: {
      img: function (tagName, attribs) {
        if (!attribs.src.startsWith("https://wvusstatic.com")) {
          attribs.src = "";
        }
        return {
          tagName: "img",
          attribs: {
            src: "",
            class: "clean-image",
          },
        };
      },
    },
  });
}

export function getZeroChildrenMessage() {
  const settings = getAppSettings();
  // TODO: Fix this in WordPress. This is a temp patch.
  const parseMessage = (txt) => txt.includes('[vc_row_inner]') ? "" : txt;
  const zeroChildrenMessage = parseMessage(settings.zeroChildrenMessage) ? (
    <span
      dangerouslySetInnerHTML={{
        __html: settings.zeroChildrenMessage,
      }}
    />
  ) : (
    <span>
      {
        "Oops, there aren't any children that match your exact search. Please remove a search parameter."
      }
    </span>
  );

  return <React.Fragment>{zeroChildrenMessage}</React.Fragment>;
}

export function getErrorMessage() {
  const windowObject = getWindowObject();
  // console.log(windowObject);
  if (
    Object.prototype.hasOwnProperty.call(
      windowObject.wv_rcds.settings,
      "errorMessage"
    )
  ) {
    return (
      <React.Fragment>
        <span
          dangerouslySetInnerHTML={{
            __html: cleanHtml(windowObject.wv_rcds.settings.errorMessage),
          }}
        ></span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      Sorry, something went wrong. Would you mind trying again? If that doesn
      {"'"}t help, give us a call at <a href="tel:8008312255">1.800.831.2255</a>{" "}
      so we can help
    </React.Fragment>
  );
}
